<template>
  <div :class="`detail-panel-${themeName}`"
       :style="panelStyle">
    <!-- Header -->
    <div v-if="$slots['header']"
         :class="`px-3 d-flex flex-row header-${themeName}`"
         :style="headerStyle">
      <slot class="pa-0"
            name="header"></slot>
    </div>

    <!-- Right drawer -->
    <div v-if="$slots['drawer']"
         class="elevation-4 drawer"
         :style="drawerStyle">
      <slot :class="`pa-0`"
            name="drawer"></slot>
    </div>

    <v-progress-linear v-if="isLoading"
                       indeterminate
                       value="15"></v-progress-linear>
    <div v-else
         style="height: 1px"></div>

    <!-- Content-->
    <div :class="`scrollContainer background lighten-1`"
         :style="contentStyle">
      <div class="scrollArea content">
        <slot name="content"></slot>
      </div>
    </div>

    <!-- Footer -->
    <div :class="`py-auto px-1 footer-${themeName} ${theme.elements.toolbarBg}`"
         :style="footerStyle">
      <div class="d-flex justify-end">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common';
export default {
  name: 'Panel',
  mixins: [common],
  props: {
    color: {
      type: String,
      default: 'white',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    headerHeight: {
      type: Number,
      default: 60,
    },

    height: Number,
    heightStr: String,
    drawer: Boolean,
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    footerHeight() {
      return this.$slots['footer'] ? 60 : 0;
    },

    headerStyle() {
      return `height:${this.headerHeight}px`;
    },
    drawerStyle() {
      return {
        transform: `translateX(${this.drawer ? '0px' : this.xs ? '100vw' : '120%'}) 
                    translateY(0px)`,
        bottom: '0px',
        top: `0px`,
        left: 0,
      };
    },
    panelStyle() {
      return { background: this.darkMode ? 'black' : 'white', opacity: 0.9, height: this.height ? this.height + 'px' : this.heightStr };
    },
    contentHeight() {
      return this.height ? this.height - this.headerHeight - this.footerHeight : null;
    },
    contentStyle() {
      if (this.contentHeight) {
        return `height:${this.contentHeight}px;`;
      }
      return `min-height:390px`;
    },

    footerStyle() {
      return `height:${this.footerHeight}px`;
    },
  },

};
</script>

<style scoped>
.drawer {
  z-index: 10000;
  transition: transform 0.5s ease-in-out;
  right: 0;
  background: #f0f0f0;
  position: absolute;
}
.detail-panel-light,
.detail-panel-dark {
  position: relative;
  transition: all 0.2s;
  border-radius: 4px;
  overflow: hidden;
}
.detail-panel-dark {
  box-shadow: 0 0 17px 1px #010101;
  border: 1px solid black !important;
}
.detail-panel-light {
  box-shadow: 0 0 17px 1px #cbc6c6;
}
.header-dark {
  border-bottom: 4px solid black;
  background: #1e1e1e !important;
}
.header-light {
  border-bottom: 0.2px solid #e0e0e0;
}
.footer-dark,
.footer-light {
  bottom: 0px;
  left: 0;
  right: 0;
}
.footer-dark {
  border-top: 1px solid #505050;
}
.footer-light {
  border-top: 0.2px solid #e0e0e0;
}
.scrollContainer {
  overflow-y: scroll;
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox*/
}

/* Hide Scrollbar for Chrome, Safari, Opera */
.scrollContainer::-webkit-scrollbar {
  display: none;
}

.scrollArea {
  height: 100%;
}
</style>
